import Vue from 'vue'
import OpUi from '@oppein/oppein-component'
import '@oppein/oppein-component/dist/oppein-component.css'

let env = 'pro'
switch (process.env.NODE_ENV) {
  case 'development':
    env = 'uat'
    break
  case 'uat':
    env = 'uat'
    break
  case 'ver':
    env = 'ver'
    break
  case 'production':
    env = 'pro'
    break
}
Vue.use(OpUi, {
  appCode: 'MMUC',
  subAppCode: 'MMUCPC001',
  env,
})
